import { createExtension, createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { manewcoDarkTheme, manewcoTheme } from './manewcoTheme';
import { MANEWCO_DARK_THEME_ID, MANEWCO_THEME_ID } from './themeIds';

/**
 * Thèmes MaNewCo, clair (`manewco`) et sombre (`manewco-dark`), seuls proposés : les thèmes
 * « light » et « dark » par défaut sont désactivés, sinon l'utilisateur en verrait quatre.
 * Identifiants repris par la bascule du menu (`nav/ThemeToggle.tsx`).
 */

const disabledDefault = (id: string) =>
  createExtension({
    kind: 'theme',
    name: id,
    attachTo: { id: 'api:app/app-theme', input: 'themes' },
    disabled: true,
    output: [],
    factory: () => [],
  });

const manewco = ThemeBlueprint.make({
  name: MANEWCO_THEME_ID,
  params: {
    theme: {
      id: MANEWCO_THEME_ID,
      title: 'MaNewCo',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={manewcoTheme}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

const manewcoDark = ThemeBlueprint.make({
  name: MANEWCO_DARK_THEME_ID,
  params: {
    theme: {
      id: MANEWCO_DARK_THEME_ID,
      title: 'MaNewCo sombre',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={manewcoDarkTheme}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [manewco, manewcoDark, disabledDefault('light'), disabledDefault('dark')],
});
